import { defineStore } from "pinia";
import { ref } from "vue";

interface ShopSettings {
  commissionRate: number;
  description: string;
  isActive: boolean;
  minOrderForFreeShipping: number;
  shippingFee: number;
  taxPercentage: number;
  taxRate: number;
  appImage: string;
  phoneSupport: string;
  emailSupport: string;
  address: string;
  timeAvailableCommission: number;
}

export const useAppStore = defineStore("appStore", () => {
  const permissions = ref<string[]>([]);
  const drawerOpen = ref<boolean>(false);
  const expandDrawer = ref<boolean>(true);
  const isMobileOrTablet = ref<boolean>(false);
  const isInitialDataLoaded = ref<boolean>(false);
  const feeConfiguration = ref<ShopSettings>({} as ShopSettings);

  const setPermissions = (items: string[]) => {
    permissions.value = items;
  };
  const isPermited = (code: string): boolean => {
    return permissions.value.find((t: string) => t === code) != undefined;
  };
  const isHavePermission = (codes: string[] | undefined): boolean => {
    if (codes == undefined || codes.length == 0) {
      return true;
    }
    let isHave = false;
    for (const code of codes) {
      if (!isHave) {
        isHave = isPermited(code);
        if (isHave) {
          break;
        }
      }
    }
    return isHave;
  };
  const isHavePermissionLazy = (
    codes: string[] | undefined
  ): Promise<boolean> => {
    return new Promise(resolve => {
      const isHave = isHavePermission(codes);
      resolve(isHave);
    });
  };

  const setDrawerOpen = (open: boolean) => {
    drawerOpen.value = open;
  };
  const setExpandDrawer = (open: boolean) => {
    expandDrawer.value = open;
  };

  const setMobileOrTablet = (state: boolean) => {
    isMobileOrTablet.value = state;
  };
  const setFeeConfiguration = (config: ShopSettings) => {
    feeConfiguration.value = config;
  };

  const setInitialDataLoaded = (loaded: boolean) => {
    isInitialDataLoaded.value = loaded;
  };

  return {
    permissions,
    setPermissions,
    isHavePermission,
    isHavePermissionLazy,
    drawerOpen,
    setDrawerOpen,
    expandDrawer,
    setExpandDrawer,
    isMobileOrTablet,
    setMobileOrTablet,
    feeConfiguration,
    setFeeConfiguration,
    isInitialDataLoaded,
    setInitialDataLoaded
  };
});
